module.exports = __webpack_public_path__ + "img/base_danios.330dec1c.gif";